import React, { Suspense } from 'react';
import { Route } from 'react-router';
import { ScrollContextProvider } from './components/GridComponents/ScrollContextProvider';
import { Loading } from './components/Loading';

const CUE100Custom = React.lazy(() => import('./pages/_custom/cuestionario/CUE100Custom'));
const CUE200Custom = React.lazy(() => import('./pages/_custom/cuestionario/CUE200Custom'));
const REC024Custom = React.lazy(() => import('./pages/_custom/recepcion/REC024Custom'));

const ADN030Custom = React.lazy(() => import('./pages/_custom/aduana/ADN030Custom'));
const ADN031Custom = React.lazy(() => import('./pages/_custom/aduana/ADN031Custom'));
const CREG103Custom = React.lazy(() => import('./pages/_custom/registro/REG103'));
const CREG104Custom = React.lazy(() => import('./pages/_custom/registro/REG104'));
const INV415Custom = React.lazy(() => import('./pages/_custom/inventario/INV415'));
const INV416Custom = React.lazy(() => import('./pages/_custom/inventario/INV416'));
const REC380 = React.lazy(() => import('./pages/_custom/recepcion/REC380'));

const REG856 = React.lazy(() => import('./pages/_custom/registro/REG856'));

const STO395 = React.lazy(() => import('./pages/_custom/stock/STO395'));
const STO396 = React.lazy(() => import('./pages/_custom/stock/STO396'));
const STO780 = React.lazy(() => import('./pages/_custom/stock/STO780'));
const STO810 = React.lazy(() => import('./pages/_custom/stock/STO810'));

const EXP700 = React.lazy(() => import('./pages/_custom/expedicion/EXP700'));

const SEG020 = React.lazy(() => import('./pages/_custom/seguridad/SEG020'));

export default function AppCustom(props) {

    return (
        <ScrollContextProvider>
            <Suspense fallback={<Loading />}>
                <Route path='/cuestionario/CUE100' render={(props) => <CUE100Custom {...props} />} />
                <Route path='/cuestionario/CUE200' render={(props) => <CUE200Custom {...props} />} />

                <Route path='/inventario/INV415' render={(props) => <INV415Custom {...props} />} />
                <Route path='/inventario/INV416' render={(props) => <INV416Custom {...props} />} />

                <Route path='/registro/REG103' render={(props) => <CREG103Custom {...props} />} />
                <Route path='/registro/REG104' render={(props) => <CREG104Custom {...props} />} />


                <Route path='/recepcion/REC380' render={(props) => <REC380 {...props} />} />
                <Route path='/stock/STO395' render={(props) => <STO395 {...props} />} />
                <Route path='/stock/STO396' render={(props) => <STO396 {...props} />} />
                <Route path='/stock/STO780' render={(props) => <STO780 {...props} />} />
                <Route path='/stock/STO810' render={(props) => <STO810 {...props} />} />

                <Route path='/recepcion/REC024' render={(props) => <REC024Custom {...props} />} />
                <Route path='/aduana/ADN030' render={(props) => <ADN030Custom {...props} />} />
                <Route path='/aduana/ADN031' render={(props) => <ADN031Custom {...props} />} />
                <Route path='/registro/REG856' render={(props) => <REG856 {...props} />} />

                <Route path='/expedicion/EXP700' render={(props) => <EXP700 {...props} />} />

                <Route path='/seguridad/SEG020' render={(props) => <SEG020 {...props} />} />
            </Suspense>
        </ScrollContextProvider>
    );

}


// WEBPACK FOOTER //
// ./src/AppCustom.js